import React, {Component} from "react";
import {connect} from "react-redux";

import MapLegend from "./MapLegend";
import MapButton from "./MapButton";

import "./MapControls.css";

class MapControls extends Component {

  render() {
    return (
      <div id="fow-map-controls">
        <MapButton action="zoomIn" />
        <MapButton action="zoomOut" />
        <MapButton action="startOver" />
        <MapLegend />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {

  };
};
const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(MapControls);
